import React, { useState } from 'react';
import './LaunchJob.styles.css';
import { LaunchNewJob, GetStatus, GetResult } from '../../../apis/apiTools';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import { Chip } from '@mui/material';

type JsonData = Record<string, any>;

export const LaunchJob: React.FC = () => {
    const [data, setData] = useState<JsonData | null>(null);
    const [dataResult, setDataResult] = useState("");
    const [status, setStatus] = useState("waiting...");

    const HandleSubmitJob = () => {
        LaunchNewJob().then((res:any) => {
            const json: JsonData = res.data;
            setData(json);
            const dataRequest = {
                "id": res.data.id
            }
            const intervalId = setInterval(() => {
                // get status
                GetStatus(dataRequest).then((res: any) => {
                    const status = res.data.status;
                    setStatus(status);
    
                    if (status === 'successful') {
                        clearInterval(intervalId);
                        // get result
                        GetResult(dataRequest).then((res: any) => {
                            setDataResult(res.data);
                        }).catch((error: any) => {
                            console.error('Error fetching status:', error);
                        });
                    }
                }).catch((error: any) => {
                    console.error('Error fetching status:', error);
                    clearInterval(intervalId);
                });
            }, 2000);
        });
    }

    return (
        <div className="page launch-job-page">
            <div className='title'>
                <h2>Launch Jobs</h2>
                <Button variant="contained" endIcon={<SendIcon />} onClick={HandleSubmitJob}>Submit</Button>
            </div>
            <pre id="result">{JSON.stringify(data, null, 2)}</pre>

            <div className='title'>
                <h2>Status</h2>
                <Chip label={status} color="success" />
            </div>

            <div className='title'>
                <h2>Result</h2>
            </div>
            {status === 'successful' ? <div id="result">{dataResult}</div> : <div id="result">Loading...</div>}
        </div>
    )
}